import { Checkbox, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, Popconfirm } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import axios from 'axios';
import AdminModal from "./AdminModal";
const { confirm } = Modal;
const { TextArea } = Input;
const EnvironmentModal = (props) => {
    const [more_information, set_more_information] = useState(false);
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    // const [person, setPerson] = useState('');
    const [environment, set_environment] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [blog_id, set_blog_id] = useState(null);
    const [other, setOther] = useState(false);
    const [modal_img, set_modal_img] = useState(false);
    const [img, setImg] = useState('');
    useEffect(() => {
        axios
            .get('/cramSchool/api/surrounding')
            .then((response) => {
                let data_tmp = [];
                // let data_json_tmp = {};
                response.data.data.map((value, index) => {
                    let data_json_tmp = {};
                    data_json_tmp['value'] = value['surrounding_id']
                    data_json_tmp['label'] = `${value['name']}`;
                    data_tmp.push(data_json_tmp);
                })
                data_tmp.push({ 'value': 0, 'label': '其他' })
                set_environment(data_tmp);
            })
    }, [])
    const handleOnChange = (id) => {
        axios
            .get('/cramSchool/api/surrounding', { params: { "surrounding_id": id } })
            .then((response) => {
                // setPerson(response.data[0].capacity);
                props.setEditCard(prev => {
                    return (
                        {
                            ...prev,
                            capacity: response.data.data[0].capacity
                        }
                    )
                })
            })
    }
    useEffect(() => {
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
            // get_picture();

        } else {
            props.setEditCard({ file_id: [], file_url: [] });
            set_blog_id('');
        }
    }, [props.editcard])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >環境介紹</Col>
                    <Col>
                        {props.edit ?
                            <>
                                <Popconfirm
                                    placement="topRight"
                                    title='確定刪除嗎？'
                                    onConfirm={e => props.handleDelete(props.editcard['blog_id'])}
                                    okText="確定"
                                    cancelText="取消"
                                >
                                    <Button style={{ backgroundColor: '#FCF5F6' }} >
                                        <Row>
                                            <Col span={6}>
                                                <img width="80%" src='/cram_school/trashicon.png'></img>
                                            </Col>
                                            <Col span={18}>
                                                <span>刪除貼文</span>
                                            </Col>
                                        </Row>
                                    </Button>
                                </Popconfirm>
                            </> :
                            <>
                            </>
                        }
                    </Col>
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={24}>
                        <Row gutter={8}>
                            <Col span={6}>環境名稱</Col>
                            <Col span={other ? 8 : 18}>
                                <Select
                                    style={{
                                        width: 120,
                                    }}
                                    labelInValue
                                    value={props.editcard.surrounding_id == 0 ? '其他' : props.editcard.title}
                                    placeholder='請選擇環境'
                                    name="title"
                                    onChange={(value) => {
                                        if (value['value'] == 0) {
                                            setOther(true)
                                            props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        title: value['label'],
                                                        surrounding_id: value['value'],
                                                        surrounding_id_type: 'insert'
                                                    }
                                                )
                                            })
                                        } else {
                                            setOther(false);
                                            props.setEditCard(prev => {
                                                return (
                                                    {
                                                        ...prev,
                                                        title: value['label'],
                                                        surrounding_id: value['value'],
                                                        surrounding_id_type: 'select'
                                                    }
                                                )
                                            });
                                            handleOnChange(value['value'])
                                        }
                                    }}
                                    options={environment}>
                                </Select>
                            </Col>
                            {other && <Col span={10}>
                                <Input placeholder='請輸入環境名稱'
                                    onChange={e =>
                                        props.setEditCard(prev => {
                                            return (
                                                {
                                                    ...prev,
                                                    title: e.target.value,
                                                }
                                            )
                                        })}></Input>
                            </Col>}
                        </Row>
                    </Col>
                    <Col span={6}>容納人數</Col>
                    {other ?
                        <>
                            <Col span={6}>
                                <Input value={props.editcard.capacity || ''}
                                    onChange={e => props.setEditCard(prev => {
                                        return (
                                            {
                                                ...prev,
                                                capacity: e.target.value,
                                            }
                                        )
                                    })}></Input>
                            </Col>
                            <Col span={12}>人</Col>
                        </>
                        : <>
                            <Col span={18}>
                                <label>{props.editcard.capacity || ''}人</label>
                            </Col>
                        </>}
                    <Col span={6}>
                        介紹內文
                    </Col>
                    <Col span={18}>
                        <TextArea rows={4} type='text' value={props.editcard.content} name="content" placeholder="請輸入環境介紹" maxLength={50}
                            autoComplete="off"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })} />
                    </Col>
                    {/* <Col span={6}></Col>
                    <Col span={18}>
                        <Checkbox checked={more_information} onChange={e => set_more_information(!more_information)}>更多內容</Checkbox>
                    </Col>
                    {
                        more_information ? <>
                            <JoditEditor
                                ref={editor}
                                value={props.data}
                                config={config}
                                tabIndex={1} // tabIndex of textarea
                                // onBlur={handleChange} // preferred to use only this option to update the content for performance reasons
                                height={500}
                                allowResizeX={true}
                                allowResizeY={true}
                            />
                        </> : null
                    } */}

                </Row>
            </AdminModal>
        </>
    )
}
export default EnvironmentModal;